import { combineReducers } from 'redux';
import currentUser from './userGroup.reducers';
import user from './user.reducers';

export default combineReducers({
  currentUser,
  user,
});
